import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("noir_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("noir_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, size, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === product.slug && i.size === size);
      if (found) {
        return prev.map((i) => (i === found ? { ...i, qty: i.qty + qty } : i));
      }
      return [...prev, { slug: product.slug, name: product.name, price: product.price, image: product.image, size, qty }];
    });
    toast.success(`${product.name} added to bag`);
    setOpen(true);
  };

  const updateQty = (slug, size, delta) => {
    setItems((prev) =>
      prev
        .map((i) => (i.slug === slug && i.size === size ? { ...i, qty: i.qty + delta } : i))
        .filter((i) => i.qty > 0)
    );
  };

  const remove = (slug, size) => setItems((prev) => prev.filter((i) => !(i.slug === slug && i.size === size)));
  const clear = () => setItems([]);

  const value = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
    const count = items.reduce((s, i) => s + i.qty, 0);
    return { items, add, updateQty, remove, clear, subtotal, count, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
